import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=89e40f36"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=89e40f36&prod&lang=css"
import style2 from "../../assets/styles/imgProduct.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports